import { Component, OnInit } from '@angular/core';
import { AdyenService } from '../services/adyen.service';
import { Store } from '../store';
import { ToolsService } from '../services/tools.service';

@Component({
    selector: 'app-adyen-payment-report',
    templateUrl: './adyen-payment-report.component.html',
    styleUrls: ['./adyen-payment-report.component.css']
})
export class AdyenPaymentReportComponent implements OnInit {

    hotels$ = this.store.select<any[]>('hotels');
    startDate;
    endDate;

    params = {
        searchTerm: '',
        name: '',
        hotelID: '',
        success: -1,
        status: '',
        bookingId: '',
        startDate: undefined,
        endDate: undefined,
        limit: 20,
        limits: [20, 50, 75, 100],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'adyen_booking_link.createdAt DESC',
        sorts: [
            { ID: 'adyen_booking_link.createdAt DESC', name: 'Recent First' },
            { ID: 'adyen_booking_link.createdAt ASC', name: 'Recent Last' },
            { ID: 'adyen_booking_link.paid DESC', name: 'Value high to low' },
            { ID: 'adyen_booking_link.paid', name: 'Value low to high' },
            { ID: 'hotel.name ASC', name: 'Hotel Name A-Z' },
            { ID: 'hotel.name DESC', name: 'Hotel Name Z-A' },
        ],
    };

    payments = [];

    constructor(
        private adyenService: AdyenService,
        private store: Store,
        private toolsService: ToolsService,
    ) { }

    ngOnInit(): void {
        this.search()
    }


    search() {
        if (this.startDate) {
            this.params.startDate = this.startDate;
        }
        if (this.endDate) {
            // this.params.endDate = this.endDate.replace('00:00:00.000Z', '23:59:59.000Z');
            const iso = this.endDate.toISOString();
            this.params.endDate = iso.replace('00:00:00.000Z', '23:59:59.000Z');
        }


        this.adyenService.searchPayments(this.params).subscribe(data => {
            console.log(data)
            this.payments = data.data;
            this.params.pages = Math.ceil(data.totalRecords / this.params.limit);
            this.params.totalRecords = data.totalRecords;
            this.params.pageArray = [];
            for (let i = 0; i < this.params.pages; i++) {
                this.params.pageArray.push(i);
            }

        })
    }

    resetParams() {
        this.startDate = undefined;
        this.endDate = undefined;
        this.params.startDate = undefined;
        this.params.endDate = undefined;
        this.params.bookingId = '';
        this.params.searchTerm = '';
        this.params.hotelID = '';
        this.params.success = -1;
        this.search();
    }

    markPaymentAsChecked(payment) {
        if (payment.paymentChecked) {
            payment.paymentChecked = false;
        } else {
            payment.paymentChecked = true;
        }
        this.adyenService.markPaymentAsChecked(payment.payUrlId).subscribe();
    }

}
